import { DeParaForm, FiltrosMapeamentoForm, MapeamentoFiltros, OperadorDescarte, RegraDescarteForm } from '../../../types/smartinteg';

export const OPERADORES_DESCARTE: { label: string; value: OperadorDescarte }[] = [
  { label: 'Vazio', value: 'EMPTY' },
  { label: 'Não vazio', value: 'NOT_EMPTY' },
  { label: 'Igual a', value: 'EQUALS' },
  { label: 'Diferente de', value: 'NOT_EQUALS' },
  { label: 'Contém', value: 'CONTAINS' },
  { label: 'Começa com', value: 'STARTS_WITH' }
];

const SEM_VALOR: OperadorDescarte[] = ['EMPTY', 'NOT_EMPTY'];
export const operadorDescarteSemValor = (o: OperadorDescarte) => SEM_VALOR.includes(o);

export function novoDePara(): DeParaForm {
  return { nomeCampo: '', dePara: {}, substituirValor: true, nomeCampoNovo: '' };
}

export function novaRegraDescarte(prioridade: number): RegraDescarteForm {
  return { nome: '', campo: '', operador: 'EQUALS', valor: '', prioridade, motivo: '' };
}

export function novosFiltrosForm(): FiltrosMapeamentoForm {
  return { deParas: [], descarteHabilitado: false, regrasDescarte: [] };
}

/** Lê ComandoMapeamento.filtros (pode vir {} ou undefined em mapeamentos sem filtros) para o formulário */
export function lerFiltros(filtros: MapeamentoFiltros | null | undefined): FiltrosMapeamentoForm {
  const dp = filtros?.filtros_de_para ?? [];
  const fd = filtros?.filtros_descarte;
  return {
    deParas: dp.map(d => ({ nomeCampo: d.nomeCampo ?? '', dePara: { ...(d.dePara ?? {}) }, substituirValor: d.substituirValor !== false, nomeCampoNovo: d.nomeCampoNovo ?? '' })),
    descarteHabilitado: !!fd?.habilitado,
    regrasDescarte: (fd?.regras ?? []).map((r, i) => ({
      nome: r.nome ?? '', campo: r.campo ?? '', operador: r.operador, valor: r.valor ?? '', prioridade: r.prioridade ?? i + 1, motivo: r.motivo ?? ''
    }))
  };
}

/** Monta ComandoMapeamento.filtros; sem nenhuma regra devolve {} (limpa o campo, não omite — PUT trata ausente como "manter") */
export function montarFiltros(form: FiltrosMapeamentoForm): MapeamentoFiltros {
  const saida: MapeamentoFiltros = {};
  if (form.deParas.length > 0) {
    saida.filtros_de_para = form.deParas.map(d => {
      const dp: any = { nomeCampo: d.nomeCampo.trim(), dePara: d.dePara, substituirValor: d.substituirValor };
      if (!d.substituirValor) dp.nomeCampoNovo = d.nomeCampoNovo.trim();
      return dp;
    });
  }
  if (form.regrasDescarte.length > 0) {
    saida.filtros_descarte = {
      habilitado: form.descarteHabilitado,
      regras: form.regrasDescarte.map(r => {
        const regra: any = { campo: r.campo.trim(), operador: r.operador, prioridade: r.prioridade };
        if (r.nome.trim()) regra.nome = r.nome.trim();
        if (r.motivo.trim()) regra.motivo = r.motivo.trim();
        if (!operadorDescarteSemValor(r.operador)) regra.valor = r.valor.trim();
        return regra;
      })
    };
  }
  return saida;
}

/** Primeiro problema do formulário, ou null se está pronto para salvar */
export function validarFiltros(form: FiltrosMapeamentoForm): string | null {
  for (const [i, d] of form.deParas.entries()) {
    const onde = `De-Para ${i + 1}`;
    if (!d.nomeCampo.trim()) return `${onde}: informe o campo de origem.`;
    if (Object.keys(d.dePara).length === 0) return `${onde}: informe ao menos um par de-para.`;
    if (!d.substituirValor && !d.nomeCampoNovo.trim()) return `${onde}: informe o campo de destino, já que "substituir o próprio campo" está desligado.`;
  }
  for (const [i, r] of form.regrasDescarte.entries()) {
    const onde = `Regra de descarte ${i + 1}`;
    if (!r.campo.trim()) return `${onde}: informe o campo.`;
    if (!operadorDescarteSemValor(r.operador) && !r.valor.trim()) return `${onde}: informe o valor.`;
    if (!Number.isInteger(r.prioridade) || r.prioridade < 1) return `${onde}: a prioridade deve ser um número inteiro a partir de 1.`;
  }
  return null;
}
